import(/* webpackMode: "eager" */ "/vercel/path0/app/programs/page.js");
